import { render, staticRenderFns } from "./TheNotation.vue?vue&type=template&id=c1b35ed0&"
import script from "./TheNotation.vue?vue&type=script&lang=js&"
export * from "./TheNotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports